(function() {
  var DialogController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.BinDetailsController = (function(superClass) {
    extend(BinDetailsController, superClass);

    function BinDetailsController(scope, transitions, modalInstance, modal, service, $q, bin, noSave) {
      var ref;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.modal = modal;
      this.service = service;
      this.bin = bin;
      this.noSave = noSave;
      BinDetailsController.__super__.constructor.apply(this, arguments);
      if (this.bin.$save == null) {
        this.bin = new this.service.StorageLocation(this.bin);
      }
      this.scope.title = 'Bin Details';
      if (this.bin.id != null) {
        this.service.StorageFan.query({
          binId: this.bin.id
        }).$promise.then((function(_this) {
          return function(fans) {
            _this.fans = fans;
            return _this._recalcMaxFanNumber();
          };
        })(this));
      } else if ((ref = this.bin.fans) != null ? ref.length : void 0) {
        this.fans = this.bin.fans;
        this._recalcMaxFanNumber();
      } else {
        this.fans = [];
        this.maxFanNumber = 0;
      }
      this.binToTruckUnloads = ['Auger', 'Belt', 'Conveyor', 'Elevator'];
      this.ladderTypes = ['Ladder w/o Platform', 'Ladder w/ Platform', 'Stairs', 'None'];
      this.inspectionSafeties = ['Good', 'Fair', 'Poor'];
      this.sensorTypes = ['Moisture', 'Temperature'];
      this.fanTypes = ['Centrifugal', 'Axial Vane'];
      this.scope.save = (function(_this) {
        return function() {
          var fan, i, idx, ref1;
          if (_this.scope.form.$invalid) {
            for (idx = i = 0, ref1 = _this.fans.length; 0 <= ref1 ? i < ref1 : i > ref1; idx = 0 <= ref1 ? ++i : --i) {
              fan = _this.scope.form.fanForms[idx];
              fan.rpm.$setDirty();
              fan.horse_power.$setDirty();
              fan.type.$setDirty();
            }
          }
          if (_this.noSave) {
            _this.bin.fans = _this.fans;
            if (_this.scope.form.$invalid) {
              return $q.resolve();
            }
            _this.modalInstance.close(_this.bin);
            return;
          }
          return _this.bin.$update().then(function() {
            var fanPromises;
            fanPromises = _this.fans.map(function(fan) {
              if (fan.id != null) {
                return fan.$update();
              } else {
                return fan.$save();
              }
            });
            return $q.all(fanPromises).then(function() {
              return _this.modalInstance.close();
            });
          })["catch"](function(err) {
            throw err;
          });
        };
      })(this);
    }

    BinDetailsController.prototype.addFan = function() {
      return this.fans.push(new this.service.StorageFan({
        fan_number: ++this.maxFanNumber,
        storage_locations_id: this.bin.id
      }));
    };

    BinDetailsController.prototype.deleteFan = function(fan) {
      var newscope;
      if (fan.id == null) {
        this.fans.splice(this.fans.indexOf(fan), 1);
        this._recalcMaxFanNumber();
        return;
      }
      newscope = this.scope.$new();
      newscope.title = 'Delete Fan';
      newscope.item_name = 'Fan';
      newscope["delete"] = (function(_this) {
        return function() {
          return fan.$delete().then(function() {
            _this.fans.splice(_this.fans.indexOf(fan), 1);
            return _this._recalcMaxFanNumber();
          });
        };
      })(this);
      return this.modal.open({
        templateUrl: 'backend/portal/home/delete-dialog',
        controller: 'DeleteDialogController',
        scope: newscope
      });
    };

    BinDetailsController.prototype.validateVolume = function() {
      if ((this.bin.eave_height == null) || (this.bin.floor_height == null)) {
        return true;
      }
      return (this.bin.eave_height - this.bin.floor_height / 12) > 0;
    };

    BinDetailsController.prototype._recalcMaxFanNumber = function() {
      return this.maxFanNumber = this.fans.map(function(fan) {
        return fan.fan_number;
      }).reduce(function(fan1, fan2) {
        return Math.max(fan1, fan2);
      }, 0);
    };

    return BinDetailsController;

  })(DialogController);

}).call(this);
